"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetEntityBuffers = void 0;
/**
 * @public
 */
function resetEntityBuffers(renderer) {
    const layouts = renderer.sharedState.entityBuffers.getAllLayouts();
    for (let i = 0, iEnd = layouts.length; i < iEnd; ++i) {
        const buffers = layouts[i].getBuffers();
        for (let j = 0, jEnd = buffers.length; j < jEnd; ++j) {
            buffers[j].resetState();
        }
    }
}
exports.resetEntityBuffers = resetEntityBuffers;
//# sourceMappingURL=reset-entity-buffers.js.map